export const initFeatures = () => {
  $(document).on('click', '.show-all-features', function (e) {
    e.preventDefault();
    $(this).fadeOut();
    $('.feature').eq(2).nextAll().slideDown();
  });
}
